export const USER_UPDATE_SUCCESS = 'User details updated successfully';
export const COMPANY_UPDATE_SUCCESS = 'Company details updated successfully';
export const COMPANY_SUBSCRIPTION_UPDATE_SUCCESS =
  'Company details updated successfully';
export const COMPANY_ADDED_SUCCESS = 'New Company created successfully';
export const USER_ADDED_SUCCESS = 'User added successfully';

export const USER_REMOVED_SUCCESS = 'User removed successfully';
export const USER_ROLE_UPDATE_SUCCESS = 'User role updated  successfully';
export const CATEGORY_CREATED_SUCCESS = 'Category created successfully';
export const RESEND_OTP_SUCCESS = 'Otp send to your email successfully';
export const MARKETING_ONBOARD_SUCCESS =
  'You have On-boarded successfully...please login!';

export const MARKETING_USER_ADDED_SUCCESS = 'Marketing User added successfully';
export const MARKETING_USER_UPDATE_SUCCESS =
  'Marketing User updated successfully';

export const MARKETING_SUBSCRIPTION_SUCCESS =
  'Marketing Subscription updated successfully';
export const BRAND_ADDED_SUCCESS = 'Brand added successfully!';

/// #########CATALOGUE#########
export const PRODUCT_DELETE_SUCCESS = 'Product delete successfully';
export const PRODUCT_STATUS_UPDTAE_SUCCESS =
  'Product status updated successfully';

// ######### OFFERINGS #########
export const OFFERING_DELETE_SUCCESS = 'Offering deleted successfully';
export const OFFERING_STATUS_UPDATE_SUCCESS =
  'Offering Status updated successfully!';

// ############# MARKET PLACE ###############
export const CONNECTION_SUCCESS = 'Your connection has been configured';
export const CONNECTION_FAILED =
  'Your shopify channel is not configured correctly please try again....!';
export const CONNECTION_DELETE_SUCCESS =
  'Your connection was deleted successfully';

// #############CAMPAIGN###############
export const CREATE_CAMPAIGN_SUCCESS = 'Campaign created successfully';
export const UPDATE_CAMPAIGN_SUCCESS = 'Campaign updated successfully';
export const DELETE_CAMPAIGN_SUCCESS = 'Campaign deleted successfully';
export const DOWNLOAD_CAMPAIGN_CSV_SUCCESS =
  'Campaign order CSV file downloaded successfully';
